import {
  GPSCoordinatesListInput,
  GPSCoordinatesListPositionPicker,
  GPSCoordinatesListRoot,
  GPSCoordinatesListUnitSelector,
} from '@components/ui/coordinatesInput/list/GPSCoordinatesList.slots';

import {
  GPSCoordinatesInput,
  GPSCoordinatesPositionPicker,
  GPSCoordinatesRoot,
  GPSCoordinatesUnitSelector,
} from './GPSCoordinates.slots';

export const GPSCoordinates = {
  Root: GPSCoordinatesRoot,
  UnitSelector: GPSCoordinatesUnitSelector,
  PositionPicker: GPSCoordinatesPositionPicker,
  Input: GPSCoordinatesInput,
};

export const GPSCoordinatesList = {
  Root: GPSCoordinatesListRoot,
  UnitSelector: GPSCoordinatesListUnitSelector,
  PositionPicker: GPSCoordinatesListPositionPicker,
  Input: GPSCoordinatesListInput,
};
